import { ViewLevelSet } from "./ViewLevelSet";
export function buildViewLevelAggregate(items) {
    const viewLevels = new ViewLevelSet();
    let requiredViewLevel = Number.MAX_SAFE_INTEGER;
    // build aggregate
    for (const item of items) {
        viewLevels.addAll(item.viewLevels);
        requiredViewLevel = Math.min(requiredViewLevel, item.requiredViewLevel);
    }
    return { requiredViewLevel, viewLevels };
}
//# sourceMappingURL=buildViewLevelAggregate.js.map